import { BlogPost } from '@/types/blog';
import { content } from './content';
import souveraenitaetHero from '@/assets/blog/souveraenitaet-komplexitaet-hero.jpg';

export const souveraenitaetKomplexitaetPost: BlogPost = {
  title: 'Souveränität in der Komplexität: Warum Wissen allein oft nicht zur Entscheidung führt',
  metaTitle: 'Souveränität & Komplexität: Katalysator-Methode für Führungskräfte',
  subtitle: 'Wie die Katalysator-Methode emotionale und kognitive Blockaden in der Führung löst',
  excerpt: 'Wenn Führungskräfte trotz Strategie feststecken: Warum Wissen allein nicht reicht und wie die Katalysator-Methode emotionale und kognitive Blockaden löst. Ohne Skripte. Mit Substanz.',
  metaDescription: 'Wenn Führungskräfte trotz Strategie feststecken: Warum Wissen allein nicht reicht und wie die Katalysator-Methode emotionale und kognitive Blockaden löst.',
  date: '27.03.2026',
  slug: 'souveraenitaet-komplexitaet-katalysator-methode',
  imageUrl: souveraenitaetHero,
  category: 'Führung',
  tags: ['Entscheidungskultur', 'Emotionale Intelligenz', 'Systemtheorie', 'Katalysator-Methode', 'Führungskräfte-Coaching', 'HSP'],
  author: 'Jörg Hörmann',
  authorTitle: 'Executive Coach & Finanzcoach',
  content
};
